import DataTable from 'datatables.net-bs5';
import 'datatables.net-responsive-dt';

import '../../../itlu/assets/js/main';

var table = new DataTable('#contract-table', {
    ajax: options.ajax_url + '?action=get_contracts&year=' + $('.button.active').text(),
    pageLength: 25,
    responsive: true,
    ordering: true,
    language: {
        url: '//cdn.datatables.net/plug-ins/1.13.5/i18n/pl.json',
    },
    columns: [
        { 
            data: 'lp',
            searchable: false
        },
        { data: 'contract_number' },
        {
            data: 'date_contract',
            orderable: true
        },
        { 
            data: 'is_eu',
            searchable: false,
        },
        {
            data: 'contract_value',
            render: $.fn.dataTable.render.number( ' ', ',', 2, '','zł' )
        },
        {
            className: 'contract-show-more',
            orderable: false,
            data: null,
            defaultContent: ''
        }
    ]
});

table.on('click', 'td.contract-show-more', function (e) {
    let tr = e.target.closest('tr');
    let row = table.row(tr);

    if (row.child.isShown()) {
        // This row is already open - close it
        row.child.hide();
    }
    else {
        // Open this row
        row.child(format(row.data())).show();
    }
});

function format(d) {
    // `d` is the original data object for the row
    return (
        '<dl>' +
        '<dt>Dane identyfikujące kontrahenta nazwa firmy wraz z numerem NIP jeżeli go posiada albo imię i nazwisko kontrahenta:</dt>' +
        '<dd>' +
        d.contractor_data +
        '</dd>' +
        '<dt>Przedmiot umowy:</dt>' +
        '<dd>' +
        d.contract_subject +
        '</dd>' +
        '<dt>Data początkowa umowy:</dt>' +
        '<dd>' +
        d.date_start +
        '</dd>' +
        '<dt>Data końcowa umowy:</dt>' +
        '<dd>' +
        d.date_end +
        '</dd>' +
        '<dt>Całkowita wartość przedmiotu umowy (netto):</dt>' +
        '<dd>' +
        numberFormat(d.contract_value, 2, ',', ' ') +
        '</dd>' +
        '<dt>Tryb zawarcia umowy:</dt>' +
        '<dd>' +
        d.contract_mode +
        '</dd>' +
        '</dl>'
    );
}

function numberFormat(number, decimals = 2, dec_point = ",", thousands_sep = " ") {
    if(number == 'zgodnie ze zużyciem') {
        return 'zgodnie ze zużyciem';
    }

    number = parseFloat(number).toFixed(decimals);
    let parts = number.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands_sep);
    return parts.join(dec_point) + 'zł';
}
